<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'dataconnection.title'"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
    <app-datatable
      [dataSource]="source"
      [columns]="columns"
      [identifier]="'dataconnections'"
      [actionNew]="canWriteDataConnections"
      [customActions]="customActions"
      [customTableActions]="customTableActions"
      (newEvent)="new()"
      (showEvent)="show($event.valueOf())"
    >
      <app-empty-table
        [icon]="'settings_input_component'"
        [emptyText]="'dataconnection.empty_text' | translate"
        [buttonText]="
          canWriteDataConnections ? ('createNew' | translate) : undefined
        "
        (btnClick)="new()"
      >
      </app-empty-table>
    </app-datatable>

    <app-error [error]="error"></app-error>
    <input
      #fileInput
      (change)="importFile($event)"
      class="d-none"
      type="file"
      accept=".json"
    />
  </div>
</div>

<ng-template #selectTemplateModal>
  <div class="modal-header flex-direction-row">
    <h4 class="modal-title">
      {{ 'dataconnection.template.select' | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      (click)="modalRef?.close()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <div class="col-md-12 form-group">
      <p>{{ 'dataconnection.template.select-text' | translate }}</p>
      <label for="data-connection-template">{{
        'dataconnection.type' | translate
      }}</label>
      <p-select
        inputId="data-connection-template"
        [(ngModel)]="selectedTemplate"
        [options]="templates"
        optionLabel="name"
        [loading]="!templates"
        [disabled]="!templates"
        [placeholder]="
          (templates ? 'dataconnection.select-type' : 'Loading...') | translate
        "
        [fluid]="true"
      />
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modalRef?.close()"
    >
      {{ 'cancel' | translate }}
    </button>
    <button
      type="button"
      [ngClass]="{ disabled: !selectedTemplate }"
      class="btn btn-secondary"
      (click)="selectTemplate()"
    >
      {{ 'next' | translate }}
    </button>
  </div>
</ng-template>
